import {
  Scale,
  Check,
  ShieldCheck,
  PenLine,
  BookMarked,
  BarChart3,
  Sparkles,
} from "lucide-react";

/**
 * Hero — bloque legal "100% Legal".
 * Se inserta entre el H1 del Hero y el párrafo descriptivo.
 */
export default function LegalBadgeCard() {
  return (
    <aside
      data-testid="hero-legal-card"
      className="relative mt-8 rounded-2xl border border-copper/30 bg-[#FBF6EC] p-5 sm:p-6 overflow-hidden"
    >
      {/* Ornament */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-16 -right-16 h-44 w-44 rounded-full bg-[radial-gradient(closest-side,rgba(193,148,86,0.18),transparent_70%)] blur-2xl"
      />

      <div className="relative">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center h-9 w-9 rounded-full bg-forest text-paper">
            <Scale size={15} className="text-[#E0C58A]" />
          </span>
          <div>
            <p className="text-[10px] tracking-[0.28em] uppercase text-copper font-medium">
              Metodología
            </p>
            <h3 className="font-serif text-[1.55rem] leading-none text-ink mt-1">
              100% Ética y Segura
            </h3>
          </div>
        </div>

        <p className="mt-3 text-[13.5px] text-ink leading-relaxed">
          Es como contratar un asesor de tesis, algo{" "}
          <span className="font-medium">completamente válido</span> en nuestros
          países bajo la figura de{" "}
          <span className="text-forest">prestación de servicios profesionales</span>.
          Pagar por orientación académica es legal, igual que contratar a un
          consultor o a un profesional independiente.
        </p>

        <p className="mt-4 text-[10px] tracking-[0.22em] uppercase text-ink-soft font-medium">
          Lo que hace nuestra plataforma por ti
        </p>
        <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-1.5" data-testid="hero-legal-list">
          <Item
            icon={Sparkles}
            title="Orientación metodológica"
            body="Hipótesis, variables y marco teórico bien estructurados."
          />
          <Item
            icon={PenLine}
            title="Corrección de estilo"
            body="Ortografía, redacción y sintaxis académica."
          />
          <Item
            icon={BookMarked}
            title="Formato de citas"
            body="Aplicar APA, Vancouver, MLA o IEEE sin errores."
          />
          <Item
            icon={BarChart3}
            title="Apoyo estadístico"
            body="Procesar los datos que tú mismo recolectaste."
          />
        </ul>

        {/* Originalidad */}
        <div className="mt-4 flex items-start gap-2.5 rounded-xl bg-white/70 border border-rule px-3.5 py-3">
          <span className="grid place-items-center h-7 w-7 shrink-0 rounded-full bg-forest/10 text-forest">
            <ShieldCheck size={13} />
          </span>
          <p className="text-[12.5px] text-ink leading-relaxed">
            <span className="text-[10px] tracking-[0.22em] uppercase text-copper font-medium block mb-0.5">
              Originalidad
            </span>
            La plataforma ayuda a{" "}
            <span className="font-medium">redactar, ordenar y citar</span>, pero
            jamás reemplaza el{" "}
            <span className="text-forest font-medium">criterio académico</span>{" "}
            del sustentante.
          </p>
        </div>

        {/* Closer */}
        <p
          data-testid="hero-legal-closer"
          className="mt-4 font-serif text-[1.05rem] text-ink text-center sm:text-left"
        >
          <span className="font-serif italic text-copper">una</span>
          <span className="font-serif">TESIS</span>
          ,{" "}
          <span className="italic text-forest">tu asesor personal</span>.
        </p>
      </div>
    </aside>
  );
}

function Item({ icon: Icon, title, body }) {
  return (
    <li className="flex items-start gap-2">
      <span className="mt-0.5 grid place-items-center h-5 w-5 shrink-0 rounded-md bg-forest text-paper">
        <Check size={11} />
      </span>
      <div>
        <p className="text-[12.5px] text-ink leading-tight">
          <span className="font-medium">{title}</span>
        </p>
        <p className="text-[11.5px] text-ink-soft leading-snug">{body}</p>
      </div>
    </li>
  );
}
